import React from "react";
import { MdExplore } from "react-icons/md";
import { HiUserGroup } from "react-icons/hi";
import { BsPlusLg } from "react-icons/bs";
import CreateGroup from "./Form/Others/CreateGroup";
import Popup from "reactjs-popup";
import { useGroup } from "../context/GroupContext";

const FeedGroup = ({ group, setGroup }) => {

  const { setLoadMyGroups } = useGroup();
  
  return (
    <div className="flex items-center pb-5">
      <div
        className={`flex items-center border-2 rounded-xl py-3 px-5 mr-3 cursor-pointer hover:border-primary hover:text-primary ${
          group === "explore" && "border-primary text-primary"
        }`}
        onClick={() => {
          setLoadMyGroups(false);
          setGroup("explore")}
        }
      >
        <MdExplore className="text-2xl" />
        <p className="text-sm pl-3">Explore</p>
      </div>
      <div
        className={`flex items-center border-2 rounded-xl py-3 px-5 mr-3 cursor-pointer hover:border-primary hover:text-primary ${
          group === "mygroups" && "border-primary text-primary"
        }`}
        onClick={() => {
          setLoadMyGroups(true);
          setGroup("mygroups")
        }}
      >
        <HiUserGroup className="text-2xl" />
        <p className="text-sm pl-3">My Groups</p>
      </div>

      <Popup
        trigger={
          <div className="flex items-center border-2 border-primary rounded-xl py-3 px-5 mr-3 cursor-pointer text-primary">
            <BsPlusLg className="text-xl" />
            <p className="text-sm pl-3">Create</p>
          </div>
        }
        position="right center"
        modal
        closeOnDocumentClick={false}
        nested
        contentStyle={{
          borderRadius: "12px",
          backgroundColor: "white",
          width: "fit-content",
          fontSize: "0.8rem",
          maxHeight: "98%",
          overflow: "auto",
        }}
      >
        {(close) => <CreateGroup close={close} />}
      </Popup>
    </div>
  );
};

export default FeedGroup;
